// removed by extract-text-webpack-plugin
module.exports = {"mark":"_3nXb0"};


//////////////////
// WEBPACK FOOTER
// ./app/components/highlighter/highlighter.scss
// module id = 973
// module chunks = 0 3 4 5 6